(() => {
	angular.module('main').directive('sendContractModal', sendContractModal);

	sendContractModal.$inject = [];

	function sendContractModal() {
		return {
			scope: true,
			template: require('./sendContract.component.html')
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/contract/sendContract.component.js